import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const Time1KeyIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M15.7762 4.63209L8.8253 11.583C8.59098 11.8173 8.59098 12.1972 8.8253 12.4315L15.7762 19.3823C16.0105 19.6167 16.3904 19.6167 16.6247 19.3823L23.5755 12.4315C23.8099 12.1972 23.8099 11.8173 23.5755 11.583L16.6247 4.63209C16.3904 4.39778 16.0105 4.39778 15.7762 4.63209Z"
        fill={color}
      />
      <path
        d="M1.79001 6.49001C1.57001 6.30001 1.20001 6.46001 1.20001 6.77001V17.23C1.20001 17.54 1.57001 17.7 1.79001 17.51L7.85001 12.46C8.14001 12.22 8.14001 11.78 7.85001 11.54L1.79001 6.49001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

Time1KeyIcon.displayName = 'Time1KeyIcon';
